import Layout from 'src/pages/layout/layout';
import Keep from 'src/pages/layout/keep';
import ReportComapny from 'src/pages/reportManage';
import DataManage from 'src/pages/dataManage';
import StationManage from 'src/pages/stationDetail';
import AlarmManage from 'src/pages/alarmManage';
import SystemConfig from 'src/pages/systemConfig';
import SystemMessage from 'src/pages/systemMessage';
import MaintenanceManage from 'src/pages/maintenanceManage';

// 不在左侧菜单显示的路由，登录、404
export const otherRouter = [
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录',
        },
        component: () => import('src/pages/login/loginq'),
    },
    {
        path: '/*',
        name: 'error-404',
        meta: {
            title: '404-页面不存在',
        },
        component: () => import('src/pages/error-page/404.vue'),
    },
];

// 在左侧菜单显示的路由
export const appRouter = [
    { path: '/', redirect: { name: 'login' } },
    {
        path: '/main',
        name: 'main',
        meta: { title: '首页' },
        component: () => import('src/pages/indexPage copy/indexPage'),
    },
    {
        path: '/gis',
        name: 'gis',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'gis-index',
                meta: { title: 'gis地图' },
                component: () => import('src/pages/gis/gis'),
            },
        ],
    },
    {
        path: '/saasAccountConfig',
        name: 'saasAccountConfig',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'saas-index',
                meta: { title: 'saas账号' },
                component: () => import('src/pages/saasAccountConfig/saasAccountConfig'),
            },
        ],
    },
    {
        path: '/feedbackOpinion',
        name: 'feedbackOpinion',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'feedback-index',
                meta: { title: '反馈意见' },
                component: () => import('src/pages/opinionFeedback/feedbackOpinion'),
            },
        ],
    },
    {
        path: '/hexfile',
        name: 'hexfile',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'hex-index',
                meta: { title: '文件目录' },
                component: () => import('src/pages/hexFileManage/hexFileTree/hexFile'),
            },
        ],
    },
    {
        path: '/sn',
        name: 'sn',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'sn-index',
                meta: { title: '离线下载器管理' },
                component: () => import('src/pages/hexFileManage/snManage/snConfig'),
            },
        ],
    },
    {
        path: '/elseSn',
        name: 'elseSn',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'elseSn-index',
                meta: { title: '其他sn管理' },
                component: () => import('src/pages/hexFileManage/elseSnManage/elseSnConfig'),
            },
        ],
    },
    {
        path: '/auth',
        name: 'auth',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'auth-index',
                meta: { title: '授权管理' },
                component: () => import('src/pages/hexFileManage/authManage/authConfig'),
            },
        ],
    },
    {
        path: '/authlog',
        name: 'authlog',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'authlog-index',
                meta: { title: '授权记录' },
                component: () => import('src/pages/hexFileManage/authLog/authLogConfig'),
            },
        ],
    },
    {
        path: '/crc',
        name: 'crc',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'crc-index',
                meta: { title: 'crc管理' },
                component: () => import('src/pages/hexFileManage/crcManage/crcConfig'),
            },
        ],
    },
    {
        path: '/roleDataCategories',
        name: 'roleDataCategories',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'roleDataCategories-index',
                meta: { title: '角色资料管理' },
                component: () => import('src/pages/roleDataManage/roleDataConfig'),
            },
        ],
    },
    {
        path: '/applicationMarket',
        name: 'applicationMarket',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'applicationMarket-index',
                meta: { title: '应用市场' },
                component: () => import('src/pages/applicationMarket/applicationMarket'),
            },
        ],
    },
    {
        path: '/biscreen',
        name: 'biscreen',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'biscreen-index',
                meta: { title: '大屏报表' },
                component: () => import('src/pages/biscreen/biscreen'),
            },
        ],
    },
    {
        path: '/mnmanage',
        name: 'mnmanage',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'mnmanage-index',
                meta: { title: 'mn管控' },
                component: () => import('src/pages/mnmanage/mnmanage'),
            },
        ],
    },
    {
        path: '/alarmManagecopy',
        name: 'alarmManagecopy',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'alarmManagecopy-index',
                meta: { title: '报警管理copy' },
                component: () => import('src/pages/alarmManageCopy/alarmSearchCopy/alarmSearch'),
            },
        ],
    },
    // {
    //     path: '/pollution',
    //     name: 'pollution',
    //     component: Layout,
    //     children: [
    //         {
    //             path: 'station',
    //             meta: { title: '站点监测' },
    //             component: Keep,
    //             children: [
    //                 {
    //                     path: 'index',
    //                     name: 'pollution-station-list',
    //                     meta: { title: '站点监测' },
    //                     component: () => import('src/pages/stationList/stationList'),
    //                 },
    //             ],
    //         },
    //     ],
    // },
    // {
    //     path: '/:type/detection',
    //     name: 'detection',
    //     component: Layout,
    //     children: [
    //         {
    //             path: 'station',
    //             meta: { title: '站点监测' },
    //             component: Keep,
    //             children: [
    //                 {
    //                     path: 'list',
    //                     name: 'surface-station-list',
    //                     meta: { title: '站点监测' },
    //                     component: () => import('src/pages/stationList/stationList'),
    //                 },
    //                 {
    //                     path: 'detail',
    //                     name: 'station-detail',
    //                     meta: { title: '站点详情' },
    //                     component: () => import('src/pages/stationDetail/stationDetail'),
    //                 },
    //             ],
    //         },
    //     ],
    // },
    {
        path: '/:type/sysconfig',
        name: 'sysconfigDetection',
        component: Layout,
        children: [
            {
                path: 'diskConfig',
                name: 'diskConfig',
                meta: { title: '硬盘机配置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-disk-config',
                        meta: { title: '硬盘机配置' },
                        component: () => import('src/pages/systemConfig/diskConfig/diskConfig'),
                    },
                ],
            },
        ],
    },
    {
        path: '/:type/alarms',
        name: 'sysconfigDetection',
        component: Layout,
        children: [
            {
                path: 'alarm',
                name: 'alarm',
                meta: { title: '报警列表' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-disk-config',
                        meta: { title: '报警列表' },
                        component: () => import('src/pages/systemConfig/alarmList/alarmList'),
                    },
                ],
            },
        ],
    },
    {
        path: '/:type/data',
        name: 'sysconfigDetection',
        component: Layout,
        children: [
            {
                path: 'management',
                name: 'management',
                meta: { title: '资料管理' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-disk-config',
                        meta: { title: '资料管理' },
                        component: () => import('src/pages/fileConfig/dataManagement/dataManagement'),
                    },
                ],
            },
        ],
    },
    ...AlarmManage,
    ...DataManage,
    ...SystemConfig,
    ...ReportComapny,
    ...MaintenanceManage,
    ...StationManage,
    ...SystemMessage,
];

export const routers = [...appRouter, ...otherRouter];
